import type { PreviewDataFlow, PreviewDataJob } from "../../lib/api";
import { Th, Td, EmptySection } from "./ui";

export function PipelinesTab({ flows, jobs }: { flows: PreviewDataFlow[]; jobs: PreviewDataJob[] }) {
  if (flows.length === 0 && jobs.length === 0) return <EmptySection label="No pipelines or jobs were emitted by this source." />;

  return (
    <div className="space-y-5">
      {flows.length > 0 && (
        <section className="card overflow-hidden">
          <div className="border-b border-rule px-6 py-4">
            <h2 className="font-display text-[16px] font-semibold tracking-tight text-ink">
              Data Flows <span className="ml-1 font-mono text-[12px] text-ash">{flows.length}</span>
            </h2>
          </div>
          <table className="w-full text-[13px]">
            <thead className="border-b border-rule bg-paper text-left">
              <tr>
                <Th>Name</Th>
                <Th className="w-36">Orchestrator</Th>
                <Th className="w-36">Flow ID</Th>
                <Th className="w-28">Cluster</Th>
              </tr>
            </thead>
            <tbody className="divide-y divide-rule">
              {flows.map((f) => (
                <tr key={f.urn} className="hover:bg-paper transition-colors">
                  <Td>
                    <div className="font-medium text-ink">{f.name}</div>
                    {f.description && <div className="mt-0.5 text-[11.5px] text-ash/80">{f.description}</div>}
                  </Td>
                  <Td><span className="font-mono text-[11.5px] text-ink">{f.orchestrator}</span></Td>
                  <Td><span className="font-mono text-[11.5px] text-ink">{f.flowId}</span></Td>
                  <Td><span className="font-mono text-[11.5px] text-ink">{f.cluster}</span></Td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      )}

      {jobs.length > 0 && (
        <section className="card overflow-hidden">
          <div className="border-b border-rule px-6 py-4">
            <h2 className="font-display text-[16px] font-semibold tracking-tight text-ink">
              Data Jobs <span className="ml-1 font-mono text-[12px] text-ash">{jobs.length}</span>
            </h2>
          </div>
          <table className="w-full text-[13px]">
            <thead className="border-b border-rule bg-paper text-left">
              <tr>
                <Th>Name</Th>
                <Th className="w-40">Job ID</Th>
                <Th className="w-40">Flow</Th>
              </tr>
            </thead>
            <tbody className="divide-y divide-rule">
              {jobs.map((j) => (
                <tr key={j.urn} className="hover:bg-paper transition-colors">
                  <Td>
                    <div className="font-medium text-ink">{j.name}</div>
                    {j.description && <div className="mt-0.5 text-[11.5px] text-ash/80">{j.description}</div>}
                  </Td>
                  <Td><span className="font-mono text-[11.5px] text-ink">{j.jobId}</span></Td>
                  <Td><span className="font-mono text-[10.5px] text-ash">{j.flowUrn}</span></Td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      )}
    </div>
  );
}
